// src/app/guards/auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';

export const AdminGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const userService = inject(UserService); // Asegúrate de importar UserService
  const router = inject(Router);
  const adminRole = 'admin'; // Define el rol de administrador

  // 1) Si ya tenemos UID en el servicio, dejamos pasar
  await authService.initAuth();

  if (authService.uid && userService.usuarioSignal()?.role === adminRole) {
    return true;
  }  

  if (!authService.uid) {
    return router.parseUrl('/auth');
  }

  // 3) Si no hay usuario, redirigimos
  router.navigateByUrl('/loading');
  return false;
};